export default {
	state: {
		vehicles: []
	},

	actions: {
		getVehicles(actionContext) {
			return new Promise(async (resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetVehicles?userid=${profile.userid}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)
							
							actionContext.commit("setVehicles", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setVehicles(state, vehicles) {
			state.vehicles = vehicles
		}
	},

	namespaced: true
}